<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>账号管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="form">
      <el-form ref="form" label-width="100px" label-position="left">
        <el-form-item label="" style="margin-left: -100px">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%">
              <el-option label="用户名" value="nickname"></el-option>
              <el-option label="直属领导" value="leader_name"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px">
            <el-input placeholder="用户名/中文名/英文名全称搜索" v-model="form.key" @keyup.enter.native="search" clearable
              @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="发布状态" prop="status">
          <el-col :span="5">
            <el-select v-model="form.status" placeholder="请选择状态" style="margin-right: 10px; width: 120px"
              :clearable="true" @change="search(false)">
              <el-option label="启用" value="1"></el-option>
              <el-option label="停用" value="2"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="部门" prop="dep_id">
          <el-col :span="5">
            <el-select v-model="form.dep_id" placeholder="请选择状态" style="margin-right: 10px; width: 120px"
              :clearable="true" @change="search(false)">
              <el-option :label="v.en_name" :value="v.id" v-for="v in departList" :key="v.id"></el-option>
            </el-select>
          </el-col>
        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div>
          <el-button icon="el-icon-plus" @click="link('/author/detail')" v-if="NodeInclude('199')">新增</el-button>
        </div>
      </div>

      <el-table :data="itemList" stripe border style="width: 100%" highlight-current-row :row-class-name="tableRowClassName">
        <el-table-column prop="nickname" label="用户名" header-align="center" align="center" min-width="150" />
        <el-table-column prop="en_name" label="英文名" header-align="center" align="center" min-width="100" />
        <el-table-column prop="realname" label="中文名" header-align="center" align="center" min-width="100" />
        <el-table-column prop="department" label="部门" header-align="center" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.department?.en_name }}
          </template>
        </el-table-column>
        <el-table-column prop="level" label="职位" header-align="center" align="center" min-width="100">
          <template slot-scope="scope">
            {{ scope.row.role?.role_name }}
          </template>
        </el-table-column>
        <el-table-column prop="position" label="职级" header-align="center" align="center" min-width="120">
          <template slot-scope="scope">
            {{ scope.row.position?.name }}
          </template>
        </el-table-column>
        <el-table-column prop="leader" label="直属领导" header-align="center" align="center" min-width="120">
          <template slot-scope="scope">
            {{ `${scope.row.leader_name} ${scope.row.leader_en_name}` }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="发布状态" header-align="center" align="center" min-width="50">
          <template slot-scope="scope">
            {{ dd.status[scope.row.status] }}
          </template>
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间" header-align="center" align="center" min-width="150" />
        <el-table-column prop="id" label="操作" min-width="80" header-align="center" align="center" fixed="right" v-if="NodeInclude('199') || NodeInclude('200')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <el-link type="primary" class="link" @click="handleClick(scope.row)"
                v-if="NodeInclude('199')">编辑</el-link>
              <el-link type="primary" class="link" @click="handleView(scope.row)" v-if="NodeInclude('200')">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>
  </el-main>
</template>

<script>
import * as api from "@/api";
import store from "@/store";
export default {
  name: "author",
  data() {
    return {
      nodeLimtList: [],
      departList: [],
      itemList: [],
      total: 0,
      p: 1,
      perPage: 30,
      // range: [],
      form: {
        dep_id: "",
        status: "",
        atype: "nickname",
      },
    };
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.type[this.form.atype],
          val: "atype",
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: "部门",
          val: "dep_id",
          value: this.getDepName(this.form.dep_id),
          active: !!this.form.dep_id,
        },
        {
          key: "发布状态",
          val: "status",
          value: this.dd.status[this.form.status],
          active: !!this.form.status,
        },
      ];
      temp = temp.filter((item) => item.active);
      return temp;
    },
  },
  mounted() {
    this.getStoreFn();
    this.getDepartList();
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      };
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(",");
      });
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val);
    },
    getDepName(did) {
      for (let i = 0; i < this.departList.length; i++) {
        const departItem = this.departList[i];
        if (departItem.leader == did) {
          return `${departItem.realname} ${departItem.en_name}`;
        }
      }
    },
    async getDepartList() {
      return new Promise((resolve) => {
        this.$fly.post("apiAccount_getDepartmentList.html", {}).then((res) => {
          this.departList = res;
          resolve(res);
        });
      });
    },
    link(url) {
      this.$router.push(url);
    },
    handleClick(item) {
      this.$router.push({ path: "/author/detail?id=" + item.id });
    },
    handleView(item) {
      this.$router.push({ path: "/author/view?id=" + item.id });
    },
    search() {
      this.p = 1;
      store.commit("setAuthorData", JSON.parse(JSON.stringify(this.form)));
      this.getList();
    },
    getStoreFn() {
      this.form =
        Object.keys(store.state.authorData).length != 0
          ? store.state.authorData
          : this.form;
      this.getList();
    },
    getList(option = {}) {
      this.checkUrlFn();
      this.checkNodeFn("61");
      const postData = {
        p: this.p,
        perPage: this.perPage,
        ...this.form,
        [this.form.atype]: this.form.key,
        ...option,
      };
      this.$fly.post("apiAccount_getUserList.html", postData).then((res) => {
        this.itemList = res.itemList;
        this.total = +res.totalNum;
      });
    },
    removeTag(tag) {
      !{
        type: () => {
          this.form["key"] = undefined;
        },
      }[tag.val]?.();
      this.form[tag.val] = "";
      store.commit("setAuthorData", JSON.parse(JSON.stringify(this.form)));
      this.getList();
      console.log(tag);
    },
    handleCurrentChange(p) {
      this.p = p;

      store.commit("setAuthorData", JSON.parse(JSON.stringify(this.form)));
      this.getList();
    },
    tableRowClassName({ row }) {
      console.log(row.status);
      if (row.status === "2") {
        return "warning-row";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;

  .filter {
    width: 85%;
  }

  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: #f2f2f2;
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}
</style>
<style lang="scss">
.el-table tr {
  &.warning-row {
    // background: #d1d1d1;

    .el-table__cell {
      color: #aaa;
    }
  }
}
</style>